import { Button, Card, CardContent } from '@material-ui/core';
import { useFormik } from 'formik';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectInput, TextInput } from '../../../../components/Forms';
import { ButtonWrapperFilter, FormGroup, useStyles } from '../../../../styles/common-styles';
import * as yup from 'yup'
import PopupHeader from '../../../common-page/popupHeader';
import { tools_crsevaluationsetup, tools_crsevaluationsetup_Mcitems } from '../../../../services/navigation_folder/tools';
import Tooltips from '../../../../utils/Tooltip/Tooltip';
import { crs_eval_master_question_Dropdown, crs_eval_master_mcitem } from '../../../../services/apiURL';
import { postApi, putApi, getApi } from '../../../../services/apiBase';
import { toastMessage } from '../../../../utils/Message/toasts';
import DefaultTable from '../../../../utils/Table/DefaultTable';

const AddMcItems = ({ onClose, selectedRow, accessFlag}) => {
    const { t } = useTranslation(["translation", "tools", "toolsHeadCells"]);

    const initialValues = {
        "mcResponseID": '',
        "mcGroupID": 0,
        "comment": "",
        "mC1Resp": "",
        "mC1Weight": "",
        "mC2Resp": "",
        "mC2Weight": "",
        "mC3Resp": "",
        "mC3Weight": "",
        "mC4Resp": "",
        "mC4Weight": "",
        "mC5Resp": "",
        "mC5Weight": "",
        "mC6Resp": "",
        "mC6Weight": "",
        "mC7Resp": "",
        "mC7Weight": "",
        "mC8Resp": "",
        "mC8Weight": "",
        "mC9Resp": "",
        "mC9Weight": "",
        "mC10Resp": "",
        "mC10Weight": ""
    }
    const validationSchema = yup.object({
        mcGroupID: yup.number()
            .min(1, t('validationMessages.isRequired', { what: t('commonLabels.group', { ns: "tools" }) }))
            .required(t('validationMessages.isRequired', { what: t('commonLabels.group', { ns: "tools" }) })),
        comment: yup.string("").required(t('validationMessages.isRequired', { what: t('commonLabels.comment', { ns: "tools" }) })),
    })
    const [formValues, setFormValues] = useState(initialValues)
    const formik = useFormik({
        initialValues: formValues,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            let payloadRequest = {
                "mcResponseID": (values.mcResponseID) ? Number(values.mcResponseID) : 0,
                "mcGroupID": (values.mcGroupID) ? Number(values.mcGroupID) : 0,
                "comment": values.comment,
                "mC1Resp": values.mC1Resp,
                "mC1Weight": (values.mC1Weight) ? Number(values.mC1Weight) : 0,
                "mC2Resp": values.mC2Resp,
                "mC2Weight": (values.mC2Weight) ? Number(values.mC2Weight) : 0,
                "mC3Resp": values.mC3Resp,
                "mC3Weight": (values.mC3Weight) ? Number(values.mC3Weight) : 0,
                "mC4Resp": values.mC4Resp,
                "mC4Weight": (values.mC4Weight) ? Number(values.mC4Weight) : 0,
                "mC5Resp": values.mC5Resp,
                "mC5Weight": (values.mC5Weight) ? Number(values.mC5Weight) : 0,
                "mC6Resp": values.mC6Resp,
                "mC6Weight": (values.mC6Weight) ? Number(values.mC6Weight) : 0,
                "mC7Resp": values.mC7Resp,
                "mC7Weight": (values.mC7Weight) ? Number(values.mC7Weight) : 0,
                "mC8Resp": values.mC8Resp,
                "mC8Weight": (values.mC8Weight) ? Number(values.mC8Weight) : 0,
                "mC9Resp": values.mC9Resp,
                "mC9Weight": (values.mC9Weight) ? Number(values.mC9Weight) : 0,
                "mC10Resp": values.mC10Resp,
                "mC10Weight": (values.mC10Weight) ? Number(values.mC10Weight) : 0
            }
            if (selectedRow) {
                putApi(`${crs_eval_master_mcitem}`, payloadRequest).then((res) => {
                    toastMessage(t('popupMessages.successIcon'), t('popupMessages.success'), t('popupMessages.successfullyUpdated'));
                    onClose(false)
                    DefaultTable.updateSelectedRow('mcItems', payloadRequest)
                }).catch((err) => {
                    console.log(err)
                })
            } else {
                postApi(`${crs_eval_master_mcitem}`, payloadRequest).then((res) => {
                    toastMessage(t('popupMessages.successIcon'), t('popupMessages.success'), t('popupMessages.successfullyAdded'));
                    onClose(false)
                    DefaultTable.resetTable('mcItems')
                }).catch((err) => {
                    console.log(err)
                })
            }
        },
    })
    const classes = useStyles();
    React.useEffect(() => {
        document.getElementsByTagName('html')[0].classList.add('popup-Page');
    }, [])

    const [Dropdown, setDropdown] = useState({
        "multipleChoiceGroup": [],
    })
    useEffect(() => {
        getApi(crs_eval_master_question_Dropdown).then((resp) => {
            const {
                multipleChoiceGroup
            } = resp.data.data
            setDropdown({
                ...Dropdown,
                "multipleChoiceGroup": (multipleChoiceGroup) ? multipleChoiceGroup : [],
            })
        }).catch((err) => {
            console.log(err);
        })
    }, [])

    useEffect(() => {        
        const normalizeWeight = (weightValue, responseValue) => {
            return (weightValue === null || weightValue === undefined || weightValue === "") ? 0 : Number(weightValue);
        }
        
        if (selectedRow) {
            setFormValues({
                ...selectedRow,
                "mC1Weight": normalizeWeight(selectedRow.mC1Weight, selectedRow.mC1Resp),
                "mC2Weight": normalizeWeight(selectedRow.mC2Weight, selectedRow.mC2Resp),
                "mC3Weight": normalizeWeight(selectedRow.mC3Weight, selectedRow.mC3Resp),
                "mC4Weight": normalizeWeight(selectedRow.mC4Weight, selectedRow.mC4Resp),
                "mC5Weight": normalizeWeight(selectedRow.mC5Weight, selectedRow.mC5Resp),
                "mC6Weight": normalizeWeight(selectedRow.mC6Weight, selectedRow.mC6Resp),
                "mC7Weight": normalizeWeight(selectedRow.mC7Weight, selectedRow.mC7Resp),
                "mC8Weight": normalizeWeight(selectedRow.mC8Weight, selectedRow.mC8Resp),
                "mC9Weight": normalizeWeight(selectedRow.mC9Weight, selectedRow.mC9Resp),
                "mC10Weight": normalizeWeight(selectedRow.mC10Weight, selectedRow.mC10Resp)
            })
        }
    }, [selectedRow])

    return (
        <>
            <PopupHeader title={(selectedRow) ? "Multiple Choice Setup" : "Add Question Type"} onClose={onClose} navigationList={tools_crsevaluationsetup_Mcitems} />

            <form onSubmit={formik.handleSubmit} className={classes.root}>
                <Card>
                    <CardContent>
                        <FormGroup>
                            <TextInput
                                isDoubled
                                disabled
                                labelId="mcResponseID"
                                label={t('commonLabels.item', { ns: "tools" })}
                                formikValue={formik.values.mcResponseID}
                                formikChange={formik.handleChange}
                            />
                            <SelectInput
                                isDoubled
                                disabled={accessFlag}
                                labelId="mcGroupID"
                                label={t('commonLabels.group', { ns: "tools" })}
                                formikValue={formik.values.mcGroupID}
                                formikChange={formik.handleChange}
                                mandatory={true}
                                errors={formik.errors.mcGroupID}
                                touched={formik.touched.mcGroupID}
                                dropdownData={{ key: "displayText", value: 'uniqueId', optionLists: Dropdown.multipleChoiceGroup }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <TextInput
                                label={t("commonLabels.comment", { ns: "tools" })}
                                labelId={"comment"}
                                formikValue={formik.values.comment}
                                formikChange={formik.handleChange}
                                isDoubled={true}
                                mandatory={true}
                                errors={formik.errors.comment}
                                touched={formik.touched.comment}
                                disabled={accessFlag}
                            />
                        </FormGroup>
                        <FormGroup>
                            <TextInput
                                label={t('mcItems.resp1', { ns: 'toolsHeadCells' })}
                                labelId={"mC1Resp"}
                                formikValue={formik.values.mC1Resp}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                            />
                            <TextInput
                                label={t('mcItems.weight1', { ns: 'toolsHeadCells' })}
                                labelId={"mC1Weight"}
                                formikValue={formik.values.mC1Weight}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                                onlyNumeric
                            />
                            <TextInput
                                label={t('mcItems.resp6', { ns: 'toolsHeadCells' })}
                                labelId={"mC6Resp"}
                                formikValue={formik.values.mC6Resp}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                            />
                            <TextInput
                                label={t('mcItems.weight6', { ns: 'toolsHeadCells' })}
                                labelId={"mC6Weight"}
                                formikValue={formik.values.mC6Weight}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                                onlyNumeric
                            />
                        </FormGroup>
                        <FormGroup>
                            <TextInput
                                label={t('mcItems.resp2', { ns: 'toolsHeadCells' })}
                                labelId={"mC2Resp"}
                                formikValue={formik.values.mC2Resp}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                            />
                            <TextInput
                                label={t('mcItems.weight2', { ns: 'toolsHeadCells' })}
                                labelId={"mC2Weight"}
                                formikValue={formik.values.mC2Weight}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                                onlyNumeric
                            />
                            <TextInput
                                label={t('mcItems.resp7', { ns: 'toolsHeadCells' })}
                                labelId={"mC7Resp"}
                                formikValue={formik.values.mC7Resp}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                            />
                            <TextInput
                                label={t('mcItems.weight7', { ns: 'toolsHeadCells' })}
                                labelId={"mC7Weight"}
                                formikValue={formik.values.mC7Weight}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                                onlyNumeric
                            />
                        </FormGroup>
                        <FormGroup>
                            <TextInput
                                label={t('mcItems.resp3', { ns: 'toolsHeadCells' })}
                                labelId={"mC3Resp"}
                                formikValue={formik.values.mC3Resp}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                            />
                            <TextInput
                                label={t('mcItems.weight3', { ns: 'toolsHeadCells' })}
                                labelId={"mC3Weight"}
                                formikValue={formik.values.mC3Weight}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                                onlyNumeric
                            />
                            <TextInput
                                label={t('mcItems.resp8', { ns: 'toolsHeadCells' })}
                                labelId={"mC8Resp"}
                                formikValue={formik.values.mC8Resp}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                            />
                            <TextInput
                                label={t('mcItems.weight8', { ns: 'toolsHeadCells' })}
                                labelId={"mC8Weight"}
                                formikValue={formik.values.mC8Weight}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                                onlyNumeric
                            />
                        </FormGroup>
                        <FormGroup>
                            <TextInput
                                label={t('mcItems.resp4', { ns: 'toolsHeadCells' })}
                                labelId={"mC4Resp"}
                                formikValue={formik.values.mC4Resp}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                            />
                            <TextInput
                                label={t('mcItems.weight4', { ns: 'toolsHeadCells' })}
                                labelId={"mC4Weight"}
                                formikValue={formik.values.mC4Weight}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                                onlyNumeric
                            />
                            <TextInput
                                label={t('mcItems.resp9', { ns: 'toolsHeadCells' })}
                                labelId={"mC9Resp"}
                                formikValue={formik.values.mC9Resp}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                            />
                            <TextInput
                                label={t('mcItems.weight9', { ns: 'toolsHeadCells' })}
                                labelId={"mC9Weight"}
                                formikValue={formik.values.mC9Weight}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                                onlyNumeric
                            />
                        </FormGroup>
                        <FormGroup>
                            <TextInput
                                label={t('mcItems.resp5', { ns: 'toolsHeadCells' })}
                                labelId={"mC5Resp"}
                                formikValue={formik.values.mC5Resp}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                            />
                            <TextInput
                                label={t('mcItems.weight5', { ns: 'toolsHeadCells' })}
                                labelId={"mC5Weight"}
                                formikValue={formik.values.mC5Weight}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                                onlyNumeric
                            />
                            <TextInput
                                label={t('mcItems.resp10', { ns: 'toolsHeadCells' })}
                                labelId={"mC10Resp"}
                                formikValue={formik.values.mC10Resp}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                            />
                            <TextInput
                                label={t('mcItems.weight10', { ns: 'toolsHeadCells' })}
                                labelId={"mC10Weight"}
                                formikValue={formik.values.mC10Weight}
                                formikChange={formik.handleChange}
                                disabled={accessFlag}
                                onlyNumeric
                            />
                        </FormGroup>
                        <div style={{ display: 'flex' }}>
                            <Tooltips flag={selectedRow} row={(selectedRow) ? {
                                insertUserID: selectedRow.insertUserId,
                                insertTime: selectedRow.insertTime,
                                updateUserID: selectedRow.updateUserId,
                                updateTime: selectedRow.updateTime
                            } : ''} />
                            <ButtonWrapperFilter>
                                <Button
                                    className='BgYellowOrange search'
                                    variant="contained"
                                    size="large"
                                    disabled={accessFlag}
                                    type="submit"
                                >
                                    {(selectedRow) ? t('buttonLabels.update', { ns: "tools" }) : t('buttonLabels.add', { ns: "tools" })}
                                </Button>
                                <Button
                                    className="BgLightBlue search"
                                    variant="contained"
                                    size="large"
                                    type="reset"
                                    onClick={() => onClose('')}
                                >
                                    {t("buttonLabels.cancel", { ns: "tools" })}
                                </Button>
                            </ButtonWrapperFilter>
                        </div>
                    </CardContent>
                </Card>
            </form>
        </>

    )
}
export default AddMcItems